<template>
  <RadioButton
    :value="value"
    :pt="{
      input: ({ state, props }) => ({
        class: [
          state.focused ? focusClass:'',
          props.modelValue === value ? 'border-theme/80':'border-gray-300 dark:border-slate-800',
          'hover:border-theme bg-white dark:bg-slate-700'
        ]
      }),
      root: {
        class: 'relative inline-flex align-bottom cursor-pointer w-[22px] h-[22px]'
      },
      icon: {
        class: 'bg-theme'
      }
    }"
  />
</template>

<script>

import RadioButton from 'primevue/radiobutton';

export default {
  name: "RpmRadioInput",
  components: {
    RadioButton,
  },
  data() {
    return {};
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    focusClass: {
      type: String,
      default: ""
    },
    borderClass: {
      type: String,
      default: ""
    },
    paddingClass: {
      type: String,
      default: ""
    },
    transitionClass: {
      type: String,
      default: ""
    },
    textClass: {
      type: String,
      default: ""
    },
  },
  methods: {},
};

</script>
